import { render, staticRenderFns } from "./RepaymentCard.vue?vue&type=template&id=a845c41a&"
import script from "./RepaymentCard.vue?vue&type=script&lang=js&"
export * from "./RepaymentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports